import { render } from "./TestPaging.vue?vue&type=template&id=264243de"
import script from "./TestPaging.vue?vue&type=script&lang=js"
export * from "./TestPaging.vue?vue&type=script&lang=js"

import exportComponent from "E:\\project\\exam\\web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__